import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterBalanceAdjustmentsView.
 * @extends JetView
 */
export default class FilterBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span>ID"), // ID label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for ID input
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'), // Datepicker label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Datepicker
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'), // Datepicker label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Date
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'TypeBalance',
                            label: _('Tipo saldo'), // Balance type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for balance type
                            value: '',
                            options: [
                                { id: '', value: _('Todos') }, // Option for all types
                                { id: '0', value: _('Saldo recargas') }, // Option for recharge balance
                                { id: '1', value: _('Saldo retiros') }, // Option for withdrawal balance
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button',
                            value: _('Añadir Ajuste'), // Add Adjustment button
                            type: 'form',
                            width: screen == 'small' ? 0 : 250,
                            minWidth: 200,
                            hidden: !devConfig.getPermAction('balanceAdjustmentsAdd', 'Add'), // Check permissions
                            css: 'prm-balanceAdjustmentsAdd',
                            click: () => {
                                this.app.callEvent('addAdjustment:button', [{}]); // Event to add adjustment
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                                    }
                                }
                                this.app.callEvent('balanceAdjustments:filter', [filterdata]); // Trigger filter event
                                $$('b5').collapse(); // Collapse the filter section
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Añadir Ajuste'), // Add Adjustment button
                    type: 'form',
                    width: screen == 'small' ? 0 : 150,
                    minWidth: 200,
                    hidden: !devConfig.getPermAction('balanceAdjustmentsAdd', 'Add'), // Check permissions
                    css: 'prm-balanceAdjustmentsAdd',
                    click: () => {
                        this.app.callEvent('addAdjustment:button', [{}]); // Event to add adjustment
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    click: () => {
                        $$('myForm2').clear(); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('balanceAdjustments:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section for scroll view
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
